function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.131 2H2.81444C2.61518 2.00185 2.41657 2.02369 2.22166 2.06525C0.932902 2.33771 0.00814438 3.47126 0 4.78853V27.6752C0 29.2087 1.28089 30.4128 2.81444 30.4128H35.131C36.6645 30.4128 37.9454 29.2087 37.9454 27.6752V4.78853C37.9454 3.25498 36.6645 2 35.131 2Z",
  fill: "#3B375B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38 10.2554C38.5523 10.2554 39 10.7031 39 11.2554V21.1175C39 21.6698 38.5523 22.1175 38 22.1175H30.6839C28.6394 22.1175 26.9819 20.46 26.9819 18.4155V13.9574C26.9819 11.9128 28.6394 10.2554 30.6839 10.2554H38Z",
  fill: "#6F6E98"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.5766 18.2339C33.6883 18.2339 34.5896 17.3327 34.5896 16.221C34.5896 15.1092 33.6883 14.208 32.5766 14.208C31.4649 14.208 30.5637 15.1092 30.5637 16.221C30.5637 17.3327 31.4649 18.2339 32.5766 18.2339Z",
  fill: "#3B375B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M44.5156 16.3828C44.8555 16.7227 45.2891 16.8984 45.8164 16.8984C46.3438 16.8984 46.7891 16.7227 47.1289 16.3828C47.4688 16.043 47.6445 15.6094 47.6445 15.1055C47.6445 14.5898 47.4688 14.1562 47.1289 13.8164C46.7891 13.4766 46.3438 13.3008 45.8164 13.3008C45.2891 13.3008 44.8555 13.4766 44.5156 13.8164C44.1758 14.1562 44 14.5898 44 15.1055C44 15.6094 44.1758 16.043 44.5156 16.3828ZM45.1748 0C44.6005 0 44.1442 0.482592 44.1764 1.05598L44.7088 10.5521C44.7385 11.0818 45.1767 11.4961 45.7072 11.4961H45.9373C46.4678 11.4961 46.906 11.0818 46.9357 10.5521L47.4681 1.05598C47.5003 0.48259 47.044 0 46.4697 0H45.1748Z",
  fill: "#3B375B"
});

var SvgNoWallet = function SvgNoWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 31,
    viewBox: "0 0 48 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-wallet.13e34795.svg";
export { ForwardRef as ReactComponent };